import alt from '../alt';
import modalAction from './modalAction';

class leaveAction {
    constructor() {
        this.generateActions(
            'processing',
            'getLASuccess',
            'search',
            'updateSM',
            'updateEM',
            'updateUI',
            'summarySuccess',
            'warningMsg',
            'shouldListShow',
            'changeStatusSuccess',
            'clear',
            'summaryClear',
            'uploadMCSuccess',
            'uploadRPSuccess',
            'isLeaveSuccess',
            'closeListShow'
        );
    }

    getLA(staffId, startYear, startMonth, endYear, endMonth) {
        if (sessionStorage.getItem('ui')) {
            let queryParams = "?staffId=" + staffId + "&startYear=" + startYear + "&startMonth=" + startMonth +
                "&endYear=" + endYear + "&endMonth=" + endMonth;

            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/leave' + queryParams, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.getLASuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    changeStatus(id, action, staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/leave/status/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.changeStatusSuccess(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "You have changed the status" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ action: action, staffId: staffId }));
        }
        return true;
    }
    uploadMC(id, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/leave/mc/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.uploadMCSuccess(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Your MC successfully uploaded" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }
    uploadReceipt(id, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/leave/receipt/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.uploadRPSuccess(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Your receipt successfully uploaded" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }
    exportSummary(staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/leaveSummary', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "Leave_Summary_" + staffId + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ staffId: staffId }));
        }
        return true;
    }
    
    exportAllSummary() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/leaveSummary/all', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "Leave_Summary_All.xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin"});
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    
    exportLA(staffId, startYear, startMonth, endYear, endMonth) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/leave', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "Leave_Application_Report_" + startYear + "-" + (startMonth + 1) + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ staffId: staffId, startYear: startYear, startMonth: startMonth, endYear: endYear, endMonth: endYear }));
        }
        return true;
    }

    getSummary(staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/leave/summary/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.summarySuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    applyLeave(fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/leave/apply', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {

                    if (xhttp.status == 200) {
                        this.isLeaveSuccess(true);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Leave applied. The page will be refresh in 3 seconds" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }
}
export default alt.createActions(leaveAction);


// WEBPACK FOOTER //
// ./app/actions/leaveAction.js